var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4165 35.4166C10.4165 36.5217 10.8555 37.5815 11.6369 38.3629C12.4183 39.1443 13.4781 39.5833 14.5832 39.5833C15.6882 39.5833 16.748 39.1443 17.5294 38.3629C18.3108 37.5815 18.7498 36.5217 18.7498 35.4166M10.4165 35.4166C10.4165 34.3116 10.8555 33.2517 11.6369 32.4703C12.4183 31.6889 13.4781 31.25 14.5832 31.25C15.6882 31.25 16.748 31.6889 17.5294 32.4703C18.3108 33.2517 18.7498 34.3116 18.7498 35.4166M10.4165 35.4166H6.24984V27.0833M18.7498 35.4166H31.2498M31.2498 35.4166C31.2498 36.5217 31.6888 37.5815 32.4702 38.3629C33.2516 39.1443 34.3114 39.5833 35.4165 39.5833C36.5216 39.5833 37.5814 39.1443 38.3628 38.3629C39.1442 37.5815 39.5832 36.5217 39.5832 35.4166M31.2498 35.4166C31.2498 34.3116 31.6888 33.2517 32.4702 32.4703C33.2516 31.6889 34.3114 31.25 35.4165 31.25C36.5216 31.25 37.5814 31.6889 38.3628 32.4703C39.1442 33.2517 39.5832 34.3116 39.5832 35.4166M39.5832 35.4166H43.7498V22.9166M4.1665 10.4166H27.0832V35.4166M43.7498 22.9166H27.0832M43.7498 22.9166L37.4998 12.5H27.0832M6.24984 18.75H14.5832",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocShip);
export default __webpack_public_path__ + "static/media/loc-ship.f3e0667afb98015e25d57ef799a0a276.svg";
export { ForwardRef as ReactComponent };